var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.58331V4.74998M6.83333 1.58331V4.74998M2.875 7.91665H17.125M4.45833 3.16665H15.5417C16.4161 3.16665 17.125 3.87553 17.125 4.74998V15.8333C17.125 16.7078 16.4161 17.4166 15.5417 17.4166H4.45833C3.58388 17.4166 2.875 16.7078 2.875 15.8333V4.74998C2.875 3.87553 3.58388 3.16665 4.45833 3.16665Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.63200bf9492bb852570ade25261178e2.svg";
export { ForwardRef as ReactComponent };